import { useQuery } from "@tanstack/react-query";
import { projectDetailsApi } from "..";

export const usePhase = (projectId: string | undefined) => {
    return useQuery({
        queryKey: ["project-phases", projectId],
        queryFn: async () => {
            return await projectDetailsApi.fetchProjectPhases(String(projectId));
        },
        enabled: !!projectId,
    });
};